import { type Routes } from '@angular/router';
import { AutoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';
import { AuthCallbackComponent } from './auth/auth-callback.component';
import { pressGuard$ } from './core/guards/press.guard';
import { superAdminGuard$ } from './core/guards/super-admin.guard';

export const routes: Routes = [
  {
    path: 'callback',
    component: AuthCallbackComponent
  },
  {
    path: '',
    loadComponent: () => import('./shared/components/layout/layout.component').then((m) => m.LayoutComponent),
    children: [
      {
        path: '',
        redirectTo: 'ring',
        pathMatch: 'full'
      },
      {
        path: 'ring',
        title: 'search.page_title',
        loadComponent: () => import('./features/ring/ring.component').then((m) => m.RingComponent)
      },
      {
        path: 'admin',
        title: 'admin.title',
        canActivate: [AutoLoginPartialRoutesGuard, superAdminGuard$],
        loadComponent: () => import('./features/admin/admin.component').then((m) => m.AdminComponent)
      },
      {
        path: 'exhibitors',
        title: 'exhibitor.page_title',
        loadComponent: () => import('./features/exhibitors/exhibitors.component').then((m) => m.ExhibitorsComponent)
      },
      {
        path: 'show-results',
        title: 'results.page_title',
        loadComponent: () =>
          import('./features/show-results/show-results.component').then((m) => m.ShowResultsComponent)
      },
      {
        path: 'press',
        title: 'press.page_title',
        canActivate: [AutoLoginPartialRoutesGuard, pressGuard$],
        loadComponent: () => import('./features/press/press.component').then((m) => m.PressComponent)
      },
      {
        path: 'logged-out',
        title: 'auth.logged_out_title',
        loadComponent: () =>
          import('./shared/components/logged-out/logged-out.component').then((m) => m.LoggedOutComponent)
      },
      {
        path: 'unauthorized',
        title: 'admin.unauthorized',
        loadComponent: () =>
          import('./shared/components/unauthorized/unauthorized.component').then((m) => m.UnauthorizedComponent)
      },
      {
        path: '**',
        redirectTo: 'ring'
      }
    ]
  }
];
